export const firebaseConfig = {
  apiKey: 'AIzaSyDBcnwC-wvLftzeDzBDolh3LdrUwhnXklY',
  authDomain: 'in-pool-34ae6.firebaseapp.com',
  projectId: 'in-pool-34ae6',
  storageBucket: 'in-pool-34ae6.appspot.com',
  messagingSenderId: '133581825041',
  appId: '1:133581825041:web:62da7f8ce18c6c04267db0',
  measurementId: 'G-4YR8GZCWDQ',
};

export const publicVapidKey =
  'BLeEAELLorDZF0MLfCAlr4eaV6BHz71F-wdaJw7y_ntgtQI6lKJVWLO6iaR4qYT7a0ns9sc280cQQLzjo08Ip74';
